import { useState } from "react";
import { Wrapper, Datagrid, DeleteActionIcon, Permission } from "components";

import { Typography, IconButton, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { endpoints } from "appConfigs";
import Form from "./Form";
import Filters from "./Filters";
import { useAppState } from "components/AppProvider/AppProvider";
import { useFetch } from "hooks";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  titleBar: {
    padding: "1rem 0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  centered: {
    margin: "0 auto",
  },
  label: {
    color: "#ffffff",
  },
  status: {
    textTransform: "capitalize",
  },
}));

const Sales = () => {
  const { authUser } = useAppState();
  const classes = useStyles();
  const [edit, setEdit] = useState(null);
  const [filters, setFilters] = useState({});
  const { remove, loading } = useFetch(endpoints.dispensarySales);
  return (
    <>
      <Wrapper padding={false}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={1} direction="column" justify="center">
              <Grid item className={classes.titleBar}>
                <Typography variant="h5">
                  <FormattedMessage id="sales" defaultMessage="Sales" />
                </Typography>
                <Permission permission="add_dispensary_sale">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setEdit(true)}
                  >
                    <FormattedMessage id="addSale" defaultMessage="Add Sale" />
                  </Button>
                </Permission>
              </Grid>
              <Grid item>
                <Card>
                  <CardContent>
                    <Filters
                      filters={filters}
                      setFilters={setFilters}
                      authUser={authUser}
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item>
                <Datagrid
                  url={endpoints.dispensarySales}
                  filters={filters}
                  columns={[
                    ...(authUser.user_type === "admin"
                      ? [
                          {
                            headerName: (
                              <FormattedMessage
                                id="hospital"
                                defaultMessage="Hospital"
                              />
                            ),
                            field: "hospital.name",
                            renderCell: ({ row }) => row.hospital?.name,
                          },
                        ]
                      : []),
                    {
                      headerName: (
                        <FormattedMessage
                          id="dispensary"
                          defaultMessage="Dispensary"
                        />
                      ),
                      field: "dispensary.name",
                      renderCell: ({ row }) => row.dispensary?.name,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="user" defaultMessage="User" />
                      ),
                      field: "user.name",
                      renderCell: ({ row }) => row.user?.name,
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="products"
                          defaultMessage="Products"
                        />
                      ),
                      field: "products",
                      renderCell: ({ row }) => row.products?.length,
                    },
                    {
                      headerName: (
                        <FormattedMessage id="status" defaultMessage="Status" />
                      ),
                      field: "status",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="action" defaultMessage="Action" />
                      ),
                      field: "action",
                      renderCell: ({ row }) => (
                        <>
                          <Permission permission="update_dispensary_sales">
                            <IconButton
                              aria-label={
                                <FormattedMessage
                                  id="editSale"
                                  defaultMessage="Edit Sale"
                                />
                              }
                              onClick={() => setEdit(row)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Permission>
                          <Permission permission="remove_dispensary_sales">
                            <DeleteActionIcon
                              disabled={loading}
                              title={
                                <FormattedMessage
                                  id="deleteSale"
                                  defaultMessage="Delete Sale"
                                />
                              }
                              message={
                                <FormattedMessage
                                  id="deleteConfirmation_dispensary_sale"
                                  defaultMessage="Are you sure want to remove this sale?"
                                />
                              }
                              deleteRecord={() => {
                                remove({ ids: row.id })
                                  .then(({ data }) => {
                                    if (data.success) {
                                      setFilters((prev) => ({ ...prev }));
                                    }
                                  })
                                  .catch((err) => {
                                    NotificationManager.error(err.message);
                                  });
                              }}
                            />
                          </Permission>
                        </>
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Form
          authUser={authUser}
          open={!!edit}
          edit={edit}
          setEdit={setEdit}
          onSuccess={(newSubPackage) => {
            setFilters((prev) => ({ ...prev }));
            setEdit(null);
          }}
        />
      </Wrapper>
    </>
  );
};

export default Sales;
